import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const AuthContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("komel_token");
    const email = localStorage.getItem("komel_email");
    
    if (token && email) {
      // Verify token
      axios.get(`${API}/auth/verify`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(() => {
          setUser({ email, token });
        })
        .catch(() => {
          localStorage.removeItem("komel_token");
          localStorage.removeItem("komel_email");
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const response = await axios.post(`${API}/auth/login`, { email, password });
    const { token } = response.data;
    
    localStorage.setItem("komel_token", token);
    localStorage.setItem("komel_email", email);
    setUser({ email, token });
    
    return response.data;
  };

  const logout = () => {
    localStorage.removeItem("komel_token");
    localStorage.removeItem("komel_email");
    setUser(null);
  };

  const getAuthHeader = () => {
    const token = localStorage.getItem("komel_token");
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, getAuthHeader }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
